<template>
    <el-form ref="form" :model="form" class="box-set" label-width="120px">
        <el-card header="设置规则名称" shadow="naver">
            <el-form-item label="名称" prop="limit_name" :rules="{required: true, message: '请填写规则名称', trigger: 'blur'}">
                <el-col :span="20">
                    <el-input v-model="form.limit_name" :maxlength=30 placeholder="最多30个字"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item label="购买规则">
                <el-input v-model="rule.day" :maxlength=30 class="inline-input" style="width: 100px"></el-input>
                天，购买
                <el-input v-model="rule.limit" :maxlength=30 class="inline-input" style="width: 100px"></el-input>
                件
                <p class="frm-tips">天数设置0视为此次活动有效期内，例如：0天，购买1件是指活动有效期内只能购买一件商品</p>
            </el-form-item>
            <el-form-item label="适用会员">
                <el-checkbox-group v-model="validGrade">
                    <el-checkbox v-for="grade in memberGrade" :label="grade.grade_id" :key="grade.grade_id">
                        {{grade.grade_name}}
                    </el-checkbox>
                    <el-checkbox v-for="vipdata in vipGrade" :label="vipdata.lv_type" :key="vipdata.lv_type">
                        付费{{vipdata.grade_name}}
                    </el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="有效期">
                <el-col :span="20">
                    <el-date-picker
                            v-model="activity_date"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="生效时间"
                            end-placeholder="过期时间"
                            format="yyyy/MM/dd HH:mm:ss"
                            value-format="timestamp"
                            :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                </el-col>
            </el-form-item>

        </el-card>
        <el-card header="选择限购商品" shadow="naver">
            <SkuSelector @change="getItems" :data="relItems"></SkuSelector>
        </el-card>
        <div class="content-center">
            <el-button type="primary" v-if="this.copy_flag" @click="submitActivityAction()">复制活动</el-button>

            <el-button type="primary" v-if="hasSaveButton && !this.copy_flag" @click="submitActivityAction()">保存</el-button>
            <el-button @click.native="handleCancel">返回</el-button>
        </div>
    </el-form>
</template>

<script>
  import SkuSelector from '@/components/function/skuSelector'
  import {getGradeList} from '../../../../api/membercard'
  import {listVipGrade} from '../../../../api/cardticket'
  import {createLimitPromotions, getLimitPromotionsInfo, updateLimitPromotions} from '../../../../api/promotions'

  export default {
    components: {
      SkuSelector
    },
    data() {
      return {
        relItems: [],
        activity_date: '',
        validGrade: [],
        vipGrade: [],
        memberGrade: [],
        rule: {
          day: 0,
          limit: 1,
        },
        copy_flag:false,
        form: {
          limit_name: '',
          items: [],
          start_time: 0,
          end_time: 0,
          valid_grade: [],
        },
        relMain: [],
        setMainStatus: false,
        mainVisible: false,
        hasSaveButton: true
      }
    },
    methods: {
      submitActivityAction() {
        const that = this
        if (this.activity_date.length > 0) {
          this.form.start_time = this.activity_date[0] / 1000
          this.form.end_time = this.activity_date[1] / 1000
        }

        if (this.validGrade.length > 0) {
          this.form.valid_grade = this.validGrade
        }
        this.form.day = this.rule.day
        this.form.limit = this.rule.limit
        if(this.copy_flag){
            delete(this.$route.params.limit_id)
        }
        if (this.$route.params.limit_id) {
          updateLimitPromotions(this.$route.params.limit_id, this.form).then(response => {
            this.loading = false
            this.$message({
              message: '修改成功',
              type: 'success',
              duration: 2 * 1000,
              onClose() {
                that.$router.go(-1)
              }
            })
          }).catch()
        } else {
          createLimitPromotions(this.form).then(response => {
            this.loading = false
            this.$message({
              message: '添加成功',
              type: 'success',
              duration: 2 * 1000,
              onClose() {
                that.$router.go(-1)
              }
            })
          }).catch()
        }
      },
      getItems(data) {
        let items = []
        data.forEach(item => {
          items.push(item.itemId)
        })
        this.form.items = items
      },
      getLimitPromotionsInfo(id) {
        getLimitPromotionsInfo(id).then(response => {
          this.form.limit_name = response.data.data.limit_name
          this.rule = JSON.parse(response.data.data.rule)
          this.relItems = response.data.data.itemTreeLists
          this.validGrade = response.data.data.valid_grade
          this.activity_date = [response.data.data.start_time * 1000, response.data.data.end_time * 1000]
        })
      },
      handleCancel() {
        this.$router.back(-1)
      },
      getListVipGrade() {
        listVipGrade().then(response => {
          if (response != undefined && response.data.data && response.data.data.length > 0) {
            this.vipGrade = response.data.data
          }
        })
      },
      getGradeList() {
        getGradeList().then(response => {
          if (response != undefined && response.data.data && response.data.data.length > 0) {
            var result = response.data.data
            if (result) {
              this.memberGrade = result
            }
          }
        })
      },
    },
    mounted() {
      this.getListVipGrade()
      this.getGradeList()
      if (this.$route.query.isshow) {
        this.hasSaveButton = false
      }
      if (this.$route.query.copy_flag) {
        this.copy_flag = true
      }
      if (this.$route.params.limit_id) {
        this.getLimitPromotionsInfo(this.$route.params.limit_id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// add.vue?ff436e40